import { render, staticRenderFns } from "./EModalFaltaAlunoFranquia.vue?vue&type=template&id=415bc296&scoped=true"
import script from "./EModalFaltaAlunoFranquia.vue?vue&type=script&lang=js"
export * from "./EModalFaltaAlunoFranquia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415bc296",
  null
  
)

export default component.exports